import type { Cart, CustomLineItem } from '@ab-core/graphql/dist';
import { ACTIVECART } from '@ab-core/hooks/cartNew/activeCart/activeCart';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import CREATE_UPDATE_SPECIAL_ARTICLE from './createCustomLineItemMutation';

export type CustomLineItemInputType = Omit<CustomLineItem, 'id'>;

type CreateOrUpdateCustomLineItemType = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: Cart;
    createOrUpdateCustomLineItem: (options?: MutationFunctionOptions) => void;
};

const CreateOrUpdateCustomLineItem = (
    cartIds?: string | string[],
    customLineItemInput?: CustomLineItemInputType
): CreateOrUpdateCustomLineItemType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(undefined);
    const [pending, setPending] = useState(false);
    const [createOrUpdateCustomLineItem, { loading }] = useMutation(CREATE_UPDATE_SPECIAL_ARTICLE, {
        variables: { cartIds, customLineItemInput },
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        },
        refetchQueries: [{ query: ACTIVECART }]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
            setSuccess(false);
            setError(false);
        }
    }, [loading]);

    return {
        createOrUpdateCustomLineItem,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};

export default CreateOrUpdateCustomLineItem;
